<template>
  <el-dialog ref="dialog" v-if="visible" :title="reversedTitle" :class="DialogClass" destroy-on-close :custom-class="customClass"
    :fullscreen="dialogFull" :close-on-click-modal="false" :show-close="showClose" :close-on-press-escape="false" :top="top" :visible.sync="visible" :width="width"
    :before-close="beforeclose" lock-scroll :append-to-body="appendToBody" :modal="modalShow" v-dialogDrag="this.ask_Dialogdrag"
    v-bind="$attrs">
    <template slot="title">
      <slot name="customTitle">
        <div class="centers">
          <span>{{ reversedTitle }}</span>
        </div>
        <div class="title-icon" v-if="zoomShow" @click="is_max">
          <i class="el-dialog__close" :class="dialogFull ? 'el-icon-news' : 'el-icon-full-screen'"></i>
        </div>
      </slot>
    </template>
    <div :key="visible" class="anonymity" ref="anonymity">
      <slot></slot>
    </div>
    <div v-if="$slots.dialog_footer" slot="footer">
      <slot name="dialog_footer"></slot>
    </div>
  </el-dialog>
</template>
<script>
/**
 * @desc 扩展dialog
 *-- @param visible { Boolean } 同element语法糖修改v-model绑定的值 （控制显隐）
 *-- @param title 传入标题
 *-- @param width 对话框宽度 默认55%
 *-- @param top  对话框距离顶部距离
 *-- @param DialogClass 传入的自定义class样式 请用 ::v-deep
 *-- @param modalShow { Boolean }  是否需要遮罩层
 *-- @param zoomShow { Boolean }  是否缩放功能
 *-- @param ask_Dialogdrag { Boolean }  是否拖拽功能
 *-- @param height { String }  对话框内容区域高度默认50vh
 **/
export default {
  name: "DialogReset",
  data() {
    return {
      dialogFull: false,
      dialogBodyHeight: 0,
    };
  },
  watch: {
    visible: {
      handler(val) {
        this.dialogFull = false;
        this.$emit("changeVisible", val);
        if (val) {
          this.$nextTick(() => {
            this.DialogBodyDomHeight();
          });
        }
      },
      immediate: true
    },
  },
  computed: {
    // -取标题优先级 props传入> 主动读取父级DialogTitle字段 > 默认    其中avue模板下嵌套业务组件固定层级为$parent.$parent.$parent
    reversedTitle() {
      return (
        this.title ||
        this.$parent.DialogTitle ||
        this.$parent.$parent.$parent.DialogTitle ||
        "操作"
      );
    },
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "55%",
    },
    top: {
      type: String,
      default: "15vh",
    },
    DialogClass: {
      type: String,
      default: "",
    },
    modalShow: {
      type: Boolean,
      default: true,
    },
    zoomShow: {
      type: Boolean,
      default: true,
    },
    ask_Dialogdrag: {
      type: Boolean,
      default: true,
    },
    height: {
      type: String,
      default: "50vh",
    },
    noNeedHeight: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    appendToBody: {
      type: Boolean,
      default: true,
    },
    beforeClose: Function,
    customClass: String
  },
  methods: {
    beforeclose() {
      if (this.beforeClose) return this.beforeClose();
      this.$emit("update:visible", false);
    },
    //缩放
    is_max() {
      this.dialogFull = !this.dialogFull;
      this.$emit("changeView", this.dialogFull);
      if (this.dialogFull) {
        // 忽略传入高度
        this.DialogBodyDomHeight("100%");
        // 缩放时处理位置
        const dragDom = this.$refs.dialog.$el.querySelector(".el-dialog");
        dragDom.style.cssText += `;left:${0}px;top:${0}px;`;
      } else {
        this.DialogBodyDomHeight();
      }
    },
    DialogBodyDomHeight(height = this.height) {
      const isFUll = height === '100%'
      if (this.noNeedHeight && height !== "100%") {
        return;
      }
      this.$nextTick(() => {
        // 动态高度部分
        let DialogBodyDom =
          this.$refs.dialog.$el.querySelector(".el-dialog__body");
        DialogBodyDom.style.height = height;
        // padding 60
        this.dialogBodyHeight = DialogBodyDom.clientHeight - 60
        this.$emit('updateHeight', this.dialogBodyHeight, DialogBodyDom, isFUll)
      });
    },
  },
};
</script>

<style scoped lang="scss">
.title-icon {
  position: absolute;
  right: 45px;
  top: 15px;
  color: #909399;
  cursor: pointer;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
}

::v-deep .el-dialog__header {
  padding: 16px 24px;
  min-height: 20px;
  border-bottom: 1px solid #f0f0f0;
}

::v-deep .el-dialog__headerbtn {
  top: 15px;
}

::v-deep .el-dialog__body {
  min-height: 25vh;
  max-height: 86vh;
  overflow: auto;
}

::v-deep .el-dialog__footer{
  border-top: 1px solid #eee;
  padding: 10px;
}
</style>
<style>
.dialog-footer {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  padding-right: 10px;
  box-sizing: border-box;
  text-align: right;
  height: 50px;
  line-height: 50px;
  background: #fff;
  z-index: 99999;
}
</style>
